import Vue from "vue";
import App from "./App.vue";
import VueTour from "vue-tour";
import router from "./router/router";
import store from "./store";
import VueAnalytics from "vue-analytics";
import VueCarousel from "vue-carousel";
import VueSweetalert2 from "vue-sweetalert2";
import es from "vee-validate/dist/locale/es";
import VeeValidate, { Validator } from "vee-validate";
import ToggleButton from "vue-js-toggle-button";
import VTooltip from "v-tooltip";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/es";
import AirbnbStyleDatepicker from "vue-airbnb-style-datepicker";
import "vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css";
import Notifications from "@voerro/vue-notifications";

require("vue-tour/dist/vue-tour.css");

const datepickerOptions = {
  days: [
    "Lunes",
    "Martes",
    "Miercoles",
    "Jueves",
    "Viernes",
    "Sabado",
    "Domingo",
  ],
  daysShort: ["Lun", "Mar", "Mie", "Jue", "Vie", "Sab", "Dom"],
  monthNames: [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Setiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ],
  colors: {
    selected: "#73c9ff",
    inRange: "#825DA5",
    selectedText: "#fff",
    text: "#565a5c",
    inRangeBorder: "white",
    disabled: "#fff",
    hoveredInRange: "#BDA0F5",
  },
  texts: {
    apply: "Aplicar",
    cancel: "Cancelar",
    keyboardShortcuts: "Keyboard Shortcuts",
  },
};
Vue.component("Notifications", Notifications);
Vue.use(ElementUI, { locale });
Vue.use(VeeValidate);
Validator.localize("es", es);
Vue.use(VueCarousel);
Vue.use(VueSweetalert2);
Vue.use(ToggleButton);
Vue.use(VTooltip);
Vue.use(AirbnbStyleDatepicker, datepickerOptions);
Vue.use(VueTour);

Vue.use(VueAnalytics, {
  id: "UA-105824776-2",
  router,
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
